import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'

class Controller extends RytmWebflow.Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
  }
  addEventListeners() {
    super.addEventListeners()
  }
  removeEventListeners() {
    super.removeEventListeners()
  }


}

export default Controller;